export const ENCRYPTED_KEY =
  'd14a028c2a3a2bc9476102bb288234c415a2b01f828ea62ac5b3e42f';
